import type { FC, ReactNode } from 'react';
import React from 'react';

import { Box } from '@mui/material';
import { components } from 'react-select';

import type { OptionType } from '@shared/ui-kit';
import type { ControlProps as RSControlProps, GroupBase } from 'react-select';

interface CustomControlProps extends RSControlProps<OptionType, boolean, GroupBase<OptionType>> {
  selectProps: RSControlProps<OptionType, boolean, GroupBase<OptionType>>['selectProps'] & {
    startIcon?: ReactNode;
  };
}

const Control: FC<CustomControlProps> = ({ children, selectProps, ...props }) => {
  return (
    <components.Control {...props} selectProps={selectProps}>
      <Box display={'flex'} alignItems={'center'} width={'100%'}>
        {selectProps?.startIcon && (
          <Box mr={'8px'} display={'flex'} alignItems={'center'}>
            <Box
              sx={{
                display: 'flex',
                height: '100%',
                alignItems: 'center',
                svg: {
                  width: '16px',
                  height: '16px',
                },
              }}
            >
              {selectProps.startIcon}
            </Box>
          </Box>
        )}
        {children}
      </Box>
    </components.Control>
  );
};
export default Control;
